const useClassesMovies = () => {
    return {
        loading: {
            display: "flex",
            justifyContent: "center",
        },
    };
};

export default useClassesMovies;
